<template>
    <ul class="rank-wrap">
        <div class="title common-title-style">
            <slot name="rank-title"></slot>
        </div>
      <template v-if="list.length">
        <div class="item-wrap">
          <li class="rank-item mouse-style" v-for="(v,i) in list" :key="v.id" @click.stop="jumpPage(v)">
            <span class="icon" v-show="i>2">{{i+1}}</span>
            <span class="icon special-wrap" v-show="i<3"><span class="special-handle">{{i+1}}</span></span>
            <span class="desc">{{v.name}}</span>
        </li>
        </div>
      </template>
      <div class="no-data" v-else>暂无数据</div>
    </ul>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    jumpPage (v) {
      if (!v.liveId) {
        return
      }
      this.$router.push({
        name: 'marketing',
        query: {
          id: v.liveId
        }
      })
    }
  }

}
</script>
<style lang="scss" scoped>
.rank-wrap{
  //width:282px;
  width:100%;
}
.rank-item{
    display:flex;
    line-height:20px;
    padding:15px 0;
    border-bottom:1px solid #eee;
    opacity: 1;
    margin:0 12px;
}
.icon{
  display:block;
  text-align:center;
  color: #999999;
}
.desc{
    flex:1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size:14px;
    padding-left:9px;
    color: #3a3a3a;
}
.rank-item .special-wrap {
    color:#ED5C4C;
}
.rank-item:last-child {
    border-bottom:none;
}
.item-wrap{
  border-radius: 6px;
  box-shadow: 0 0 3px #eee;
  background:#fff;
}
.no-data{
  background:#fff;
  text-align:center;
  padding:50px 0;
}
</style>
